import { render, staticRenderFns } from "./IconActiveFilters.vue?vue&type=template&id=bbd21b6a&"
import script from "./IconActiveFilters.vue?vue&type=script&lang=js&"
export * from "./IconActiveFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports